export const resume = {
  name: "Chuku Success",
  role: "SOFTWARE ENGINEER",
  phone: "(+234) 809-322-5648",
  email: "successchuku5@gmail.com",
  urls: {
    linkedin: "https://linkedin.com/in/success-chuku-b58724236",
    twitter:
      "https://twitter.com/Ulquiorra_ciffa?t=qcT77F_yHemTPeMpqP3ysw&s=08",
    github: "https://github.com/chukusuccess",
  },
  experiences: [
    {
      company_name: "Greater Washington LTD (GWX)",
      company_location: "Nigeria",
      position: "Software Engineer (Remote).",
      start_date: "MAY 2024",
      end_date: "AUGUST 2024",
      company_description:
        "At GWX Logistics, I was part of an agile team, handling frontend development for in-house software solutions.",
      responsibilities: [
        "Designed and developed the entire frontend for a logistics software handling 600+ shipments, including a role-based admin dashboard, rider app, and shipment tracking app.",
        "Built a real-time tracking interface with a working map and geolocation for shipment monitoring.",
        "Developed interfaces for pickup scheduling and rider assignment, streamlining operational workflows.",
        "Implemented role-based login and access control for secure user authentication.       ",
        "Integrated Node.js endpoints for creating shipments, assigning shipments to riders, authentication, and retrieving shipment details by order number.",
        "Enabled data visualization in the admin dashboard and implemented downloading and printing shipment records in Excel and PDF formats.",
      ],
      app_url: "",
    },
    {
      company_name: "Africa Manufacturing Innovation Hub",
      company_location: "Nigeria",
      position: "Software Engineer (Remote).",
      start_date: "AUGUST 2022",
      end_date: "APRIL 2024",
      company_description:
        "As a key member of the Africa Manufacturing Innovation Hub (AMI Hub), I’ve been instrumental in driving tech innovation across Africa. ",
      responsibilities: [
        "Revamped AMI Hub’s landing page using Next.js, Tailwind, and Node.js, achieving a 20% faster load time, 30% higher user engagement, and a 20% increase in Sci-Tech 23 hackathon conversions.",
        "Built the Sci-Tech 23 hackathon registration portal with full SEO, boosting online page visibility.",
        "Developed an online/offline (PWA) Command Centre for the ‘Proxie’ Microcontroller with React.js, Tailwind, and Ant Design/AntV, enhancing graph visualization and interaction.",
        "Rebuilt ‘Proxie’s’ offline Command Centre using vanilla HTML, CSS, and JavaScript, resolving OOM issues and improving communication speed by 40% via WebSockets.       ",
        "Introduced QR code-based admin-guest approvals, cutting human delays by 90% and enhancing user experience.",
        "Developed Axios API instances for seamless CRUD operations with a Python (Django) backend, boosting client-side scalability.",
        "Conducted technical presentations and demos on ‘Proxie’ pre-release builds for in-house staff.",
      ],
      app_url: "",
    },
    {
      company_name: "OatoMedia LTD",
      company_location: "Nigeria",
      position: "Software Engineer (Remote).",
      start_date: "JUNE 2019",
      end_date: "JANUARY 2023",
      company_description:
        "At OatoMedia, I was part of an agile team and played a pivotal role in the development, deployment, and maintenance of software solutions for OatoMedia clients.",
      responsibilities: [
        "Applied Test-Driven Development (TDD), reducing post-release defects by 30% and ensuring reliable, bug-free code.       ",
        "Developed frontend components using Ant Design and LESS, enhancing user experience and receiving 15% more positive QA/QC feedback.",
        "Built Axios API instances for seamless communication with Node.js, NestJS, and PostgreSQL backend, improving code maintainability via separation of concerns.",
        "Designed DTOs, models, schema, migrations, and seeders for efficient PostgreSQL data management in test and development environments.",
        "Optimized asynchronous CRUD operations with Bluebird, boosting network request efficiency by 50%.",
        "Created React contexts and custom hooks for network request handling and global data manipulation, improving frontend responsiveness.        ",
        "Implemented Sequelize for efficient backend data sorting, limiting, and counting, achieving a 5% server-side and 20% client-side performance improvement.        ",
        "Contributed to code reviews and daily standups, enhancing software reliability and scalability through SDLC best practices.",
      ],
      app_url: "",
    },
  ],
  skills: [
    {
      name: "JavaScript",
      years_of_exp: "6",
    },
    {
      name: "HTML & CSS",
      years_of_exp: "6",
    },
    {
      name: "Git/Github",
      years_of_exp: "6",
    },
    {
      name: "Node.Js",
      years_of_exp: "4",
    },
    {
      name: "MongoDB",
      years_of_exp: "4",
    },
    {
      name: "APIs",
      years_of_exp: "4",
    },
    {
      name: "TailwindCSS",
      years_of_exp: "3",
    },
    {
      name: "TypeScript",
      years_of_exp: "3",
    },
    {
      name: "PostgreSQL",
      years_of_exp: "3",
    },
    {
      name: "React/NextJs",
      years_of_exp: "3",
    },
    {
      name: "Unit Testing",
      years_of_exp: "3",
    },
    {
      name: "Jira & Sentry",
      years_of_exp: "2",
    },
    {
      name: "C#",
      years_of_exp: "2",
    },
  ],
  projects: [
    // {
    //   company_name: `NextGen Doctors`,
    //   company_location: "Nigeria",
    //   position: "Founder & Software Engineer",
    //   start_date: "APRIL 2023",
    //   end_date: "MAY 2023",
    //   company_description:
    //     "NextGen Doctors is a personal project I started in April 2023, in attempt to win a Hackathon. It solves the problem of poor access to health care.",
    //   responsibilities: [
    //     "Building Reusable User-friendly components using NextJs, Tailwind and AntD.",
    //     "Making performance optimizations for faster loading times.",
    //     "Testing unit components to ensure code doesn't break",
    //     "Initializing backend",
    //     "Creating Database schema",
    //     "Connecting Frontend to Backend",
    //     "Implementing Authentication",
    //     "Implementing CRUD operations",
    //     "Implementing QR code generation and encryption",
    //     "Implementing QR code decrypting",
    //   ],
    //   app_url: "https://nextgen-doctors.vercel.app/",
    // },
    // {
    //   company_name: `NextGen Patients`,
    //   company_location: "Nigeria",
    //   position: "Founder & Software Engineer",
    //   start_date: "APRIL 2023",
    //   end_date: "MAY 2023",
    //   company_description:
    //     "NextGen Patients is the patients side of NextGen Doctors.",
    //   responsibilities: [
    //     "Building Reusable User-friendly components using NextJs, Tailwind and AntD.",
    //     "Making performance optimizations for faster loading times.",
    //     "Testing unit components to ensure code doesn't break",
    //     "Initializing backend",
    //     "Creating Database schema",
    //     "Connecting Frontend to Backend",
    //     "Implementing Authentication",
    //     "Implementing CRUD operations",
    //     "Implementing apointment booking",
    //   ],
    //   app_url: "https://next-gen-patients.vercel.app/",
    // },
    // {
    //   company_name: `Codematic Quizzer`,
    //   company_location: "Nigeria",
    //   position: "Founder & Software Engineer",
    //   start_date: "OCTOBER 2023",
    //   end_date: "OCTOBER 2023",
    //   company_description: "Simple quiz app built with React and Trivia API",
    //   responsibilities: [
    //     "Built Frontend components with React Js.",
    //     "Connected Frontend to Trivia API",
    //     "Implemented Quiz logic",
    //     "Tested unit components",
    //   ],
    //   app_url: "https://codematic-quizzer.vercel.app",
    // },
    // {
    //   company_name: `iYield Searchbar`,
    //   company_location: "Nigeria",
    //   position: "Founder & Software Engineer",
    //   start_date: "OCTOBER 2023",
    //   end_date: "OCTOBER 2023",
    //   company_description: "Search bar",
    //   responsibilities: [
    //     "Built Frontend components with Next Js.",
    //     "Connected Frontend to REST Countries API",
    //     "Implemented Search logic",
    //     "Tested unit components",
    //   ],
    //   app_url: "https://iyield-searchbar.vercel.app/",
    // },
  ],
  languages: [
    {
      name: "English",
      level: "fluent",
    },
  ],
  education: {
    university_name: "University of Port Harcourt",
    location: "Choba, Port Harcourt",
    degree: "B.Sc. Computer Science",
    start_date: "November 2017",
    end_date: "November 2021",
    text: "Bachelor's degree in Computer Science – University of Port Harcourt.",
  },
  works: [
    {
      company_name: "Africa Manufacturing Innovation Hub",
      href: "https://amihub.africa/",
      position: "Software Engineer (Remote).",
      text: "NextJs, ReactJs, HTML5, CSS, TailwindCSS, JavaScript, AntDesign, NodeJs, PostgreSQL",
      url: ["/amidesk.png", "/amimob.png", "/ami2desk.png", "/ami2mob.png"],
    },
    // {
    //   company_name: "NBCS",
    //   href: "http://www.nbcs.netlify.app/",
    //   company_location: "Nigeria",
    //   position: "Software Engineer",
    //   text: "NextJs, TailwindCSS, AntDesign, Firestore",
    //   url: ["/nbcsdesk.png", "/nbcsmob.png", "/nbcs2desk.png", "/nbcs2mob.png"],
    // },
    // {
    //   company_name: "CMR",
    //   position: "Software Engineer (Remote).",
    //   text: "ReactJs, TailwindCSS, Firebase",
    //   url: ["/cmrdesk.png", "/cmrmob.png"],
    // },
    {
      company_name: "Impact Summit",
      href: "https://impactsummit.network/",
      position: "Software Engineer (Remote).",
      text: "NextJs, TailwindCSS, JavaScript, AntDesign",
      url: [
        "/impactdesk.png",
        "/impactmob.png",
        "/impactdesk1.png",
        "/impactmob1.png",
      ],
    },
    {
      company_name: "Dinma",
      href: "https://getdinma.com/",
      position: "Software Engineer (Remote).",
      text: "NextJs, TailwindCSS, AntDesign, Python",
      url: [
        "/dinmadesk.png",
        "/dinmamob.png",
        "/dinmadesk1.png",
        "/dinmamob1.png",
      ],
    },
    // {
    //   company_name: "iYield Searchbar",
    //   href: "https://iyield-searchbar.vercel.app/",
    //   position: "Software Engineer (Remote).",
    //   text: "NextJs, TypeScript, TailwindCSS, AntDesign",
    //   url: [
    //     "/iyielddesk.png",
    //     "/iyieldmob.png",
    //     "/iyielddesk1.png",
    //     "/iyieldmob1.png",
    //   ],
    // },
  ],
  notes: [
    {
      rich_text: (
        <p className="text-justify font-lora text-xs sm:text-xl">
          — As I look back on the past year, It came to a close in a way better
          bearing than it started with. I can't help but feel a sense of{" "}
          <b>accomplishment</b> and <b>Improvement</b> having gotten better at{" "}
          <b>TypeScript</b> and gotten a high-paying contract for it, launching
          a product for the company I work with, and taking a deeper dive into{" "}
          <b>PostgreSQL</b> and <i>Kubernetes</i> with <b>Docker</b>. I've
          learned so much and grown as a developer in many ways during the past
          year. Even though sometimes I thought it wasn't going to get easier
          but things got easier for the simple reason that{" "}
          <b>
            the challenges I faced only made me stronger and more resilient.
          </b>{" "}
          —
        </p>
      ),
      note_title: "Reflecting on my Dev career, - Dev Retro 2022.",
      minutes: 3,
      image_url:
        "https://cdn.hashnode.com/res/hashnode/image/upload/v1673021917667/76dcab47-43e0-4262-8044-4c93defe2952.jpeg?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp",
      hashnode_url:
        "https://chukusuccess.hashnode.dev/reflecting-on-my-dev-career-dev-retro-2022",
    },
    {
      rich_text: (
        <p className="text-justify font-lora text-xs sm:text-xl">
          — 😅 Lol, to be honest, the idea was conceived out of not having the
          budget to hire a UI designer to design a portfolio website for me, and
          not having the budget to purchase expensive web templates but meh,{" "}
          <b>I'm creative after all.</b> One random morning, I just thought{" "}
          <b>"Why don't I build what looks exactly like my resume?"</b> and here
          you have it, my unique portfolio, with a little more spice than my
          resume tho but undeniably elegant. —
        </p>
      ),
      note_title: "My Creative Approach to Portfolio Design.",
      minutes: 3,
      image_url: "/write.jpg",
      hashnode_url:
        "https://chukusuccess.hashnode.dev/standing-out-on-a-budget-my-creative-approach-to-portfolio-design",
    },
    {
      rich_text: (
        <p className="text-justify font-lora text-xs sm:text-xl">
          — In this article, we will explore the process of integrating a
          Next.js project with Appwrite as a BaaS provider.
          <b />
          Appwrite offers a comprehensive and easy to use set of secure APIs,
          tools, and a perosnal management console to facilitate the development
          of your applications. <b />I recommend using Appwrite but you need to
          visit their docs to truly understand what exactly each service does
          and how best to use it. —
        </p>
      ),
      note_title: "Next.js + Appwrite BaaS.",
      minutes: 13,
      image_url: "/appwrite.jpg",
      hashnode_url: "https://chukusuccess.hashnode.dev/nextjs-appwrite-baas",
    },
  ],
};
